import { render, staticRenderFns } from "./OnboardingInsurance.vue?vue&type=template&id=3580e144&scoped=true"
import script from "./OnboardingInsurance.vue?vue&type=script&lang=js"
export * from "./OnboardingInsurance.vue?vue&type=script&lang=js"
import style0 from "./OnboardingInsurance.vue?vue&type=style&index=0&id=3580e144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3580e144",
  null
  
)

export default component.exports